import React from "react";
import AntdTimePicker, { TimePickerProps } from "antd/lib/time-picker";
import {withError} from '@fishx/tracker';

const RangePicker = AntdTimePicker.RangePicker;

interface TPProps extends TimePickerProps {
  forwardedRef?: any;
}
interface FCTPProps extends React.FC<TPProps> {
  RangePicker: typeof RangePicker;
}
export const TimePicker: FCTPProps = (props) => {
   const { forwardedRef, ...rest } = props;
   return <AntdTimePicker ref={forwardedRef} {...rest} />
}
TimePicker.RangePicker = RangePicker;
TimePicker.displayName = 'TimePicker';
export default withError(TimePicker, {forwardRef: true});



// WEBPACK FOOTER //
// ./src/components/time-picker/index.tsx